<div class="guide-completed-modal">
  <div class="container" *ngIf="!isLoading">
    <!-- Header -->
    <div class="header-title">
      <mat-icon fontSet="material-icons-outlined" class="header-icon">check_circle</mat-icon>
      <h6 class="title-large">{{ modalTitle }}</h6>
      <button mat-icon-button class="close-btn" (click)="close()">
        <mat-icon fontSet="material-icons-outlined">close</mat-icon>
      </button>
    </div>

    <!-- Content -->
    <div class="content">
      <p class="message" [innerHTML]="modalText">
      </p>
    </div>

    <!-- Footer Actions -->
    <div class="actions">
      <button class="def-button" (click)="close()">
        {{ buttonLabel }}
      </button>
    </div>
  </div>
</div>
